import InviteUserModal from '@/components/modals/UserInvitationModal.vue';
import { toastResponse } from '@/common/handleServerResponse';

export default {
  components: {
    InviteUserModal,
  },
  data() {
    return {
      showCreateInvitation: false,
    };
  },
  methods: {
    openInvitationModal() {
      this.showCreateInvitation = true;
    },
    closeModal() {
      this.showCreateInvitation = false;
    },
    async invitationSent(res) {
      this.closeModal();
      toastResponse(this, res, 'Your invitation has been sent');
      await this.$store.dispatch('userInvitations/getUserInvitations', {});
    },
  },
};
